<template>
  <v-dialog
    v-model="loading"
    persistent
    width="400"
  >
    <v-card>
      <v-card-title>{{ titulo }}</v-card-title>

      <v-card-text>
        <v-progress-linear
          indeterminate
          color="success"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    titulo: {
      type: String,
      default: 'Por favor, aguarde',
    },
  },
}
</script>
